module.exports = __webpack_public_path__ + "static/fengtu-fb5e78c1d36abf84b87a9bcd117ee43e.jpg";